import { spiritoryWebApi } from '@/lib/axios/spiritoryWebApi';
import { SpiritoryWebEndpoints } from '@/types/api/api-v2';

export default async function doGetSku(slug: string) {
  try {
    const data = await spiritoryWebApi.get(`/sku/${slug}` as SpiritoryWebEndpoints);
    return data.data;
  } catch (err) {
    console.log(err);
    return null;
  }
}
